module.exports = __webpack_public_path__ + "static/media/pix.b4f4df4d.png";